import { Link } from "react-router-dom";
import PageMeta from "../components/PageMeta";
import { Button } from "../components/ui/button";
import GetTheAppCard from "../components/GetTheAppCard";
import { MapPin, Heart, BellRinging, ArrowRight } from "@phosphor-icons/react";

const BASE = "https://thetrucktrackr.com";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "MobileApplication",
  name: "TheTruckTrackr",
  operatingSystem: "iOS, Android",
  applicationCategory: "FoodApplication",
  url: "https://apps.apple.com/us/app/thetrucktrackr/id6783500007",
  sameAs: ["https://play.google.com/store/apps/details?id=com.thetrucktrackr.app"],
  offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
};

const STEPS = [
  {
    icon: MapPin,
    title: "Open the map",
    body: "See every truck posted today — where they're parked, when they open, and how far away they are.",
  },
  {
    icon: Heart,
    title: "Follow your favorites",
    body: "One tap to follow a truck. Their upcoming schedule shows on their profile all week.",
  },
  {
    icon: BellRinging,
    title: "Get pinged",
    body: "Push notifications when a truck you follow posts a new spot — or is serving near you right now.",
  },
];

export default function ForFans() {
  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-12 sm:py-16" data-testid="for-fans-page">
      <PageMeta
        title="Find Food Trucks Near You — Free Live Map | TruckTrackr"
        description="TruckTrackr is free for food truck fans. See a live map of trucks serving today, follow your favorites, and get notified when they're open near you."
        canonical={`${BASE}/customers`}
        jsonLd={JSON_LD}
      />

      <span className="text-xs uppercase tracking-[0.2em] text-primary font-medium">For food truck fans</span>
      <h1 className="mt-3 font-display font-bold tracking-tighter text-4xl sm:text-5xl">
        Never miss your <span className="text-primary">favorite truck</span> again.
      </h1>
      <p className="mt-4 text-base md:text-lg text-muted-foreground max-w-2xl">
        Free, no account required to browse. Open the map, see who's serving
        today, and go eat.
      </p>

      <div className="mt-8">
        <Link to="/map" data-testid="fans-cta-map">
          <Button size="lg" className="gap-2 h-12 px-6 rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
            <MapPin weight="duotone" className="h-5 w-5" />
            Find trucks near me
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>

      <div className="mt-12 grid gap-4 sm:grid-cols-3">
        {STEPS.map((s, i) => (
          <div key={s.title} className="rounded-2xl border border-border bg-card p-6">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-xl bg-primary/15 text-primary grid place-items-center">
                <s.icon weight="duotone" className="h-5 w-5" />
              </div>
              <span className="text-xs font-bold text-muted-foreground">0{i + 1}</span>
            </div>
            <h2 className="mt-4 font-display font-semibold text-base md:text-lg tracking-tight">{s.title}</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-12">
        <GetTheAppCard />
      </div>
    </div>
  );
}
